import { Badge, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { AccountConstraint } from '../_openapi/portfolio-optimizer';
import { toAccountConstraintFields } from './accountConstraintFields';

/** The account constraint the algos run on, above the growth table. */
export const AccountConstraintRow = ({ accountConstraint }: { accountConstraint?: AccountConstraint | null }) => {
    const fields = toAccountConstraintFields(accountConstraint);
    if (fields.length === 0) {
        return null;
    }
    return (
        <Flex gap={8} px={2} pb={2} fontSize="sm">
            {fields.map((field) => (
                <Text key={field.label}>
                    <Text as="span" color="gray.500">
                        {field.label}
                    </Text>{' '}
                    {field.value}
                    {field.isCapped && (
                        <Badge colorScheme="orange" ml={1}>
                            capped
                        </Badge>
                    )}
                </Text>
            ))}
        </Flex>
    );
};
